import React from 'react';

import {
  EditablePropertyField,
  EditPropertyFieldInputType,
} from '../../edit/EditablePropertyField';
import { WipConfig } from 'packages/creditAgreements/ui/types';

const propertyFieldsConfig: {
  basePropertyKey: string;
  label: string;
  inputType?: EditPropertyFieldInputType;
  isEditDisabled?: boolean;
}[] = [
  {
    basePropertyKey: 'covenantKey',
    label: 'Key',
    isEditDisabled: true,
  },
  {
    basePropertyKey: 'name',
    label: 'Name',
  },
  {
    basePropertyKey: 'section',
    label: 'Credit Agreement Section',
  },
  {
    basePropertyKey: 'description',
    label: 'Description',
    inputType: 'textArea',
  },
];

export const PortfolioCovenantEditProperties = ({
  wipConfig,
  fullPropertyKey,
}: {
  wipConfig: WipConfig;
  fullPropertyKey: string;
}) => {
  return (
    <>
      {propertyFieldsConfig.map((property) => (
        <EditablePropertyField
          wipConfig={wipConfig}
          fullPropertyKey={fullPropertyKey}
          basePropertyKey={property.basePropertyKey}
          label={property.label}
          isEditDisabled={property.isEditDisabled}
          key={property.basePropertyKey}
          inputType={property.inputType}
        />
      ))}
    </>
  );
};
